module.exports = __webpack_public_path__ + "static/rollo-primavera-1-c3cd406c575c3afa63f782b01054da4d.jpg";